module.exports = __webpack_public_path__ + "static/media/YF11_3.166a1281.jpg";